"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m19 18 2 1V1H7v2h12zM17 5H3v18l7-3 7 3z"
}), 'BookmarksSharp');